module.exports = __webpack_public_path__ + "media/application/images/icons/ui-icons_555555_256x240-3b3aad9e842a18f6659dbd2c62c16eee.png";